import RazorPay from './razor-pay';

export default RazorPay;
